import React from 'react';
import { withLoadingAndNoConnectionHandler } from '../integration-wrapper';
import { FormView } from './form-view/FormView';
import { useContract } from '../contracts';
import { useCategorySelection } from './form-view/category-selection/useCategorySelection';

export const Request: React.FC<object> = () => {
    const { data: contracts, isLoading, loadingError } = useContract();
    const { data: categoryResponse, loadingError: isLoadingErrorCategoryResponse } = useCategorySelection();

    const RequestWithHandlers = withLoadingAndNoConnectionHandler(FormView);

    return (
        <RequestWithHandlers
            categoryResponse={categoryResponse}
            isLoading={isLoading}
            contracts={contracts}
            hasError={!!loadingError || !!isLoadingErrorCategoryResponse}
        />
    );
};
